"use client";

import { Suspense } from "react";
import DataTabs from "@/components/DataTabs";

export default function PatternsPage() {
  return (
    <main>
      <Suspense fallback={<div>Loading...</div>}>
        <DataTabs initialTab="patterns" showTabBar={false} />
      </Suspense>
    </main>
  );
}
